import { get, post, put, Delete } from "../axios";

// 参数配置-查看
export const systemParamView = (params) => get("/web/system/param/view");

// 参数配置-修改
export const systemParamUpdate = (params) =>
  put("/web/system/param/update", params);
